/* ============================================================
   HOUSE OF VALOR — Theme JavaScript
   File: assets/valor.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Nav scroll ink ── */
  const nav = document.querySelector('.valor-nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Hero parallax ── */
  const heroBg = document.querySelector('.valor-hero__bg');
  if (heroBg) {
    window.addEventListener('scroll', () => {
      heroBg.style.transform = `translateY(${window.scrollY * 0.28}px)`;
    }, { passive: true });
  }

  /* ── Scroll reveal ── */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('animated');
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.will-animate').forEach(el => revealObserver.observe(el));

  /* ── Cart drawer ── */
  const overlay = document.querySelector('.valor-cart-overlay');
  const drawer  = document.querySelector('.valor-cart-drawer');

  function openCartDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.querySelector('.valor-cart-drawer__close')?.focus();
  }

  function closeCartDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Expose globally for Liquid templates
  window.valorOpenCart  = openCartDrawer;
  window.valorCloseCart = closeCartDrawer;

  overlay?.addEventListener('click', closeCartDrawer);
  document.querySelector('.valor-cart-drawer__close')?.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCartDrawer() });

  // Cart trigger buttons
  document.querySelectorAll('[data-valor-cart-trigger]').forEach(btn => {
    btn.addEventListener('click', openCartDrawer);
  });

  /* ── Refresh cart drawer via AJAX ── */
  async function refreshCartDrawer() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();

      // Update all count badges
      document.querySelectorAll('[data-valor-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });

      // Update subtotal
      document.querySelectorAll('[data-valor-cart-subtotal]').forEach(el => {
        el.textContent = formatMoney(cart.total_price);
      });

      // Re-render items via section rendering API
      const sectionRes = await fetch('/?sections=cart-drawer');
      if (sectionRes.ok) {
        const sections = await sectionRes.json();
        if (sections['cart-drawer']) {
          const tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          const newItems = tmp.querySelector('.valor-cart-drawer__items');
          const curItems = document.querySelector('.valor-cart-drawer__items');
          if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;
          attachCartItemHandlers();
        }
      }
    } catch (err) {
      console.error('Valor: cart refresh error', err);
    }
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ── Add to cart (product form) ── */
  const productForm = document.querySelector('[data-valor-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn  = productForm.querySelector('[data-valor-atc]');
      const span = btn?.querySelector('span');
      if (!btn || btn.disabled) return;

      btn.disabled = true;
      if (span) span.textContent = 'Adding…';

      const variantId = productForm.querySelector('[name="id"]')?.value;
      const quantity  = parseInt(productForm.querySelector('[name="quantity"]')?.value || 1);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });

        if (res.ok) {
          if (span) span.textContent = 'Added to Cart';
          await refreshCartDrawer();
          setTimeout(() => {
            openCartDrawer();
            btn.disabled = false;
            if (span) span.textContent = 'Add to Cart';
          }, 800);
        } else {
          const err = await res.json();
          if (span) span.textContent = err.description || 'Sold Out';
          btn.disabled = false;
        }
      } catch (err) {
        if (span) span.textContent = 'Error – Try Again';
        btn.disabled = false;
      }
    });
  }

  /* ── Cart item quantity / remove ── */
  function attachCartItemHandlers() {
    // Qty buttons
    document.querySelectorAll('[data-valor-qty-change]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key   = btn.dataset.valorQtyChange;
        const delta = parseInt(btn.dataset.delta || 0);
        const qtyEl = btn.closest('.valor-cart-drawer__item')
                         ?.querySelector('[data-valor-line-qty]');
        const cur   = parseInt(qtyEl?.textContent || 1);
        const next  = Math.max(0, cur + delta);
        await updateCartItem(key, next);
      });
    });

    // Remove buttons
    document.querySelectorAll('[data-valor-remove]').forEach(btn => {
      btn.addEventListener('click', async () => {
        await updateCartItem(btn.dataset.valorRemove, 0);
      });
    });
  }

  async function updateCartItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCartDrawer();
    } catch (err) {
      console.error('Valor: cart update error', err);
    }
  }

  attachCartItemHandlers();

  /* ── Product gallery thumbnails ── */
  document.querySelectorAll('.valor-product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImg = document.querySelector('.valor-product-gallery__photo');
      if (!mainImg) return;
      document.querySelectorAll('.valor-product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = thumb.dataset.src || thumb.querySelector('img')?.src;
        mainImg.style.opacity = '1';
      }, 280);
    });
  });

  /* ── Size selector on product page ── */
  document.querySelectorAll('.valor-size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('.valor-product-info__sizes');
      wrap?.querySelectorAll('.valor-size-btn').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      // Update hidden variant input
      const variantId = btn.dataset.variantId;
      if (variantId) {
        const input = document.querySelector('[name="id"]');
        if (input) input.value = variantId;
      }
    });
  });

  /* ── Quantity stepper on product page ── */
  document.querySelectorAll('[data-valor-qty-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector('[name="quantity"]');
      if (input) input.value = Math.max(1, parseInt(input.value) - 1);
    });
  });
  document.querySelectorAll('[data-valor-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector('[name="quantity"]');
      if (input) input.value = Math.min(10, parseInt(input.value) + 1);
    });
  });

  /* ── Card size buttons (collection / homepage) ── */
  document.querySelectorAll('.valor-card__sizes').forEach(wrap => {
    wrap.querySelectorAll('.valor-card__size').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        wrap.querySelectorAll('.valor-card__size').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
      });
    });
  });

  /* ── Collection filters ── */
  document.querySelectorAll('.valor-filter-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.valor-filter-tab').forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      const type = tab.dataset.filter || 'all';
      document.querySelectorAll('[data-product-type]').forEach(card => {
        if (type === 'all') {
          card.style.display = '';
        } else {
          card.style.display = card.dataset.productType?.toLowerCase() === type ? '' : 'none';
        }
      });
    });
  });

  document.querySelectorAll('.valor-filter-pill').forEach(pill => {
    pill.addEventListener('click', () => pill.classList.toggle('is-active'));
  });

})();
